import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  env: string;
  apiBaseURL: string;
  candidateApiBaseURL: string;
  candidatePortalURL: string;
  languageDetectionURL: string;
  languageDetectionApiKey: string;
  LandingPageURL: string;
  LandingPageURLCandidate: string;
  developerAPIKey: string = 'f48113fd-06ca-6413-3919-f22d7ef95cd8';
  protected apiUrls = {
    local: 'http://localhost:8080/api/v3',
     'dev': 'https://api-dev.certiplate.com/api/v3',
    'qa': 'https://api-qa.certiplate.com/api/v3',
    'uat': 'https://api-uat.certiplate.com/api/v3',
    prod: 'https://api-prod.certiplate.com/api/v3'
  }
  protected LandingPageRedirection = {
    local: 'http://localhost:4200',
    'dev': 'https://dev.certiplate.com',
    'qa': 'https://qa.certiplate.com',
    'uat': 'https://uat.certiplate.com',
    prod: 'https://certiplate.com'
  }
  protected LandingPageRedirectionCandidate = {
    local: 'http://localhost:5173/',
    'dev': 'https://exams-dev.certiplate.com/',
    'qa': 'https://exams-qa.certiplate.com/',
    'uat': 'https://exams-uat.certiplate.com/',
    prod: 'https://exams.certiplate.com/'
  }
  protected candidateUrls = {
    local: 'http://localhost:8081/api/v3',
    'dev': 'https://api-exams-dev.certiplate.com/api/v3',
    'qa': 'https://api-exams-qa.certiplate.com/api/v3',
    'uat': 'https://api-exams-uat.certiplate.com/api/v3',
    prod: 'https://api-exams-prod.certiplate.com/api/v3'
  }
  protected candidatePortalUrls = {
    local: 'http://localhost:5173/',
    'dev': 'https://exams-dev.certiplate.com/',
    'qa': 'https://exams-qa.certiplate.com/',
    'uat': 'https://exams-uat.certiplate.com/',
    prod: 'https://exams.certiplate.com/'
  }

  protected languageDetectionUrl = {
    local: 'https://api-lang-detect-dev.certiplate.com',
    'dev': 'https://api-lang-detect-dev.certiplate.com',
    'qa': 'https://api-lang-detect-qa.certiplate.com',
    'uat': 'https://api-lang-detect-uat.certiplate.com',
    prod: 'https://api-lang-detect.certiplate.com'
  }

  protected languageDetectionApiKeys = {
    local: 'dev-ffa85ce4-d8af-4232-97b0-2a7d5aec7c45',
    'dev': 'dev-ffa85ce4-d8af-4232-97b0-2a7d5aec7c45',
    'qa': 'qa-ffa85ce4-d8af-4232-97b0-2a7d5aec7c42',
    'uat': 'uat-ffa85ce4-d8af-4232-97b0-2a7d5aec7c45',
    prod: '4c7d4fe2-a9e7-4b2f-8fd9-6a4d4e8bb2d2'
  };

  constructor() {
    this.init();
  }

  init(){
    // setup env
    if (window.location.hostname === 'localhost') {
      this.env = 'local';
    } else {
      const environment = window.location.host.replace('.certiplate.com', '');
      this.env = ['dev', 'qa', 'uat'].includes(environment) ? environment : 'prod';
    }
    this.apiBaseURL = this.apiUrls[this.env];
    this.candidateApiBaseURL = this.candidateUrls[this.env];
    this.candidatePortalURL = this.candidatePortalUrls[this.env];
    this.languageDetectionURL = this.languageDetectionUrl[this.env];
    this.languageDetectionApiKey = this.languageDetectionApiKeys[this.env];
    this.LandingPageURL = this.LandingPageRedirection[this.env];
    this.LandingPageURLCandidate = this.LandingPageRedirectionCandidate[this.env];
  }
}

